import styled from 'styled-components'

export const StyledProjectDetailsWrapper = styled.div`
  .projects-api-key {
    &__block {
      grid-template-columns: 30% calc(40% + 140px) calc(30% - 140px);
      @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
      }
    }
    &__row {
      display: grid; 
      grid-template-columns: 1fr repeat(2, 50px);
      grid-gap: 10px;
      align-items: center;
      
      @media screen and (max-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        & > div {
          width: 100%;
        }
      }
    }
    &__show {
      width: 50px;
      height: 50px;
      color: #45CAA7;
      font-size: 20px;
      outline: none;
      border: 1px solid #29DE67;
      background-color: rgba(41, 219, 172, 0.1);
      border-radius: 50%;
      transition: all .3s ease;
      &:hover {
        color: #fff;
        border: 1px solid transparent;
        background: linear-gradient(40deg, #277661 -20%, #29DEAE 70%);
      }   
    }
  }
`;

export const StyledProjectConnections = styled.div`
  .projects-connection-head {
    padding: 60px 0 30px;
  }
  .projects-connection-table {
    &__head {
      grid-template-columns: 200px 350px 125px 125px 175px;
    }
    &__row {
      grid-template-columns: 200px 350px 135px 135px 175px;
    }
  }
`;

export const StyledProjectWebhooks = styled.div`
  .projects-webhooks-form {
    padding-top: 60px;
    padding-bottom: 30px;
    display: grid;
    grid-auto-columns: max-content;
    grid-template-rows: 55px;
    button {
      height: 100%;
    }
  }
  
  .projects-webhooks-table {
    &__head {
      grid-template-columns: 160px 450px 1fr;
    }
    &__row {
      grid-template-columns: 160px 450px 1fr;
      @media screen and (max-width: 1920px) {
        & > div:last-child {
          justify-content: flex-end;
        }
      }
    }
    &__link {
      max-width: 450px;
      width: 100%;
      overflow-wrap: break-word;
      cursor: pointer;
    }
  }
`;

export const StyledProjectWhiteList = styled.div`
  .white-list-head {
    padding-top: 60px;
    padding-bottom: 30px;
    display: grid;
    grid-auto-columns: max-content;
    grid-template-rows: 55px;
    button {
      height: 100%;
    }
  }

  .projects-ip-list {
    &__item {
      display: grid;
      grid-template-columns: 1fr 50px;
      grid-gap: 10px;
      align-items: start;
    }

    &__remove {
      width: 50px;
      height: 50px;
      color: #FB4B6B;
      font-size: 20px;
      outline: none;
      border: 1px solid #de2929;
      background-color: rgba(219, 41, 41, 0.1);
      border-radius: 50%;
      transition: all .3s ease;
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      &:hover {
        color: #fff;
        border: 1px solid transparent;
        background: linear-gradient(40deg, #FF0000 30%, #FB4B6B 90%);
      }
    }
  }
`;